<template>
  <div id="shop-products" class="container-fluid">

    <h1 class="shop-heading">Shop <span v-html="$root.domainTrademark"></span> Coatings</h1>

    <marketing-banner></marketing-banner>

    <div id="main-content">

      <filters-sidebar v-show="this.activeSubCollections.length <= 0 && !parentCategoryExclusions" />

      <section id="products-and-pills">

        <filter-pills v-show="!activeSubCollections.length" />

        <div
          v-if="showInfoBox && selectedCollectionCategory.collection_page_text !== null && selectedCollectionCategory.collection_page_text.length > 0"
          class="collection-info">
          <h2>{{ selectedCollectionCategory.collection_page_title }}</h2>
          <p>{{ selectedCollectionCategory.collection_page_text }}</p>
        </div>

        <div id="sub-categories" v-show="activeSubCollections.length">
          <div class="sub-category-card" v-for="(subCollections, index) in activeSubCollections" :key="index">
            <a :href="`/shop/cerakote-coating?finishes=${subCollections.code}`">
              <div class="thumbnail">
                <img v-if="subCollections.mobile_image_url !== null" :src="`${subCollections.mobile_image_url}`">
                <div class="text-center image-fallback" v-else>
                  <i class="fa fa-picture-o fa-5x" aria-hidden="true"></i>
                </div>
                <div class="caption">
                  <h4>{{ subCollections.name }}</h4>
                </div>
              </div>
            </a>
          </div>
        </div>

        <products @add-swatch-to-cart="addSwatchToCart" v-if="this.activeSubCollections.length <= 0" />

      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Products from './products/Products';
import FiltersSidebar from "./sidebar/FiltersSidebar.vue";
import FilterPills from "./sidebar/filters/FilterPills";
import MarketingBanner from './MarketingBanner.vue'

export default {
  name: 'ShopMainContent',

  components: {
    Products,
    FiltersSidebar,
    FilterPills,
    MarketingBanner
  },

  computed: {
    ...mapGetters([
      'selectedCollectionCategory',
      'navBar'
    ]),

    showInfoBox() {
      return Object.keys(this.selectedCollectionCategory).length > 0;
    },

    hasSelectedParentCollection() {
      const parentCollection = this.selectedCollectionCategory.parent_category_refs;

      if (parentCollection !== undefined && parentCollection.length && parentCollection[0].name === 'Collections') {
        return true;
      }

      return false;
    },

    activeSubCollections() {
      const parentCategory = this.selectedCollectionCategory.parent_category_refs;
      const subCategory = this.selectedCollectionCategory.sub_categories;

      if (parentCategory !== undefined && parentCategory.length) {
        return parentCategory[0].name === 'Collections' ? subCategory.filter((active) => {
          return active.enabled;
        }) : [];
      }

      return [];
    },

    parentCategoryExclusions() {
      const parentCategory = this.selectedCollectionCategory.parent_category_refs;
      const excludeParentName = [
        'Equipment',
      ];

      if (parentCategory !== undefined && parentCategory.length) {
        return excludeParentName.indexOf(parentCategory[0].name) > -1;
      }

      return false;
    },
  },

  methods: {
    addSwatchToCart(swatch) {
      this.$emit('add-swatch-to-cart', swatch);
    }
  }
}
</script>

<style lang="scss">
#shop-products {
  width: 100%;

  #main-content {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-top: 25px;

    #sub-categories {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(31.5%, 1fr));
      grid-gap: calc(2.6vmin);
      width: 100%;
      margin-bottom: 25px;

      .sub-category-card {
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        overflow: hidden;

        .caption {
          z-index: 2;
          background-color: #fff;
        }

        .thumbnail {
          margin: 0;
          padding: 0;

          img {
            max-height: 150px;
            max-width: inherit;
            width: 100%;
            -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
            transition: opacity 0.35s, transform 0.35s;
            -webkit-transform: scale(1);
            transform: scale(1);

            &:hover {
              opacity: 0.5;
              -webkit-transform: scale(1.05);
              transform: scale(1.05);
            }
          }

          .image-fallback {
            padding: 10px;
          }
        }
      }

      @media (max-width: 1024px) {
        grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
      }

      @media (max-width: 768px) {
        grid-template-columns: repeat(auto-fill, minmax(45%, 1fr));

        .thumbnail {
          .caption {
            color: #fff;
            background-color: #f99839;
          }

          h4 {
            min-height: 40px;
            font-size: 1.4rem;
          }

          img {
            display: none;
          }
        }
      }
    }

    @media (max-width: 768px) {
      flex-direction: column;
    }

    #products-and-pills {
      display: flex;
      flex-grow: 1;
      flex-direction: column;

      .collection-info {
        margin-bottom: 25px;
        background-color: #FFF;
        padding: 15px;
        border-radius: 6px;
        display: inline-block;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        width: 100%;
        color: #393939;
      }

      @media (max-width: 768px) {
        padding: 0;
      }
    }
  }
}
</style>
